import * as React from 'react';
import { SVGProps } from 'react';

const EmptyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 81 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_252_107005)">
      <path
        d="M74.9245 33.5918H46.9415V70.4034H74.9245C77.6753 70.4034 79.9053 68.1832 79.9053 65.4445V38.5507C79.9053 35.812 77.6753 33.5918 74.9245 33.5918ZM72.5459 61.4127C72.5459 62.3257 71.8026 63.0657 70.8857 63.0657H51.9223V40.9293H70.8857C71.8026 40.9293 72.5459 41.6693 72.5459 42.5823V61.4127Z"
        fill="#FFEED0"
      />
      <path
        d="M46.9415 70.4034H66.0036V63.0657H51.9223V40.9293H66.0036V33.5918H46.9415V70.4034Z"
        fill="#FFDFA6"
      />
      <path
        d="M50.8197 79.999H13.6767C9.23185 79.999 5.62872 76.3957 5.62872 71.951V23.7051H58.8678V71.951C58.8678 76.3957 55.2645 79.999 50.8197 79.999Z"
        fill="#FFEED0"
      />
      <path
        d="M15.143 23.7051H5.6286V71.9509C5.6286 76.3957 9.23188 79.9988 13.6766 79.9988H23.1909C20.0774 73.801 16.1378 64.1665 14.4708 51.7938C12.8999 40.1334 13.9256 30.3349 15.143 23.7051Z"
        fill="#FFDFA6"
      />
      <path
        d="M19.0399 57.0035C21.7315 57.0035 23.9134 55.2735 23.9134 53.1395C23.9134 51.0054 21.7315 49.2754 19.0399 49.2754C16.3482 49.2754 14.1663 51.0054 14.1663 53.1395C14.1663 55.2735 16.3482 57.0035 19.0399 57.0035Z"
        fill="#FFDFA6"
      />
      <path
        d="M45.4564 57.0035C48.148 57.0035 50.33 55.2735 50.33 53.1395C50.33 51.0054 48.148 49.2754 45.4564 49.2754C42.7648 49.2754 40.5828 51.0054 40.5828 53.1395C40.5828 55.2735 42.7648 57.0035 45.4564 57.0035Z"
        fill="#FFDFA6"
      />
      <path
        d="M32.2481 49.034C30.3147 49.034 28.5928 47.7404 27.5099 49.3358C26.4113 50.954 28.8717 53.4633 32.2481 53.4633C35.6246 53.4633 38.0849 50.954 36.9864 49.3358C35.9035 47.7404 34.1817 49.034 32.2481 49.034Z"
        fill="#677187"
      />
      <path
        d="M21.8804 50.3426C20.7132 50.3426 19.603 49.839 18.8344 48.961C18.4018 48.4668 18.4518 47.7154 18.946 47.2828C19.4404 46.8503 20.1916 46.9001 20.6243 47.3943C20.9411 47.7564 21.3989 47.964 21.8804 47.964C22.3616 47.964 22.8194 47.7564 23.1364 47.3943C23.5691 46.9 24.3205 46.8501 24.8147 47.2828C25.3089 47.7154 25.3589 48.4668 24.9263 48.961C24.1575 49.839 23.0474 50.3426 21.8804 50.3426Z"
        fill="#677187"
      />
      <path
        d="M42.6162 50.3426C41.4491 50.3426 40.3389 49.839 39.5703 48.961C39.1377 48.4668 39.1877 47.7154 39.6819 47.2828C40.1761 46.8503 40.9275 46.9001 41.3602 47.3943C41.677 47.7564 42.1348 47.964 42.6162 47.964C43.0975 47.964 43.5553 47.7564 43.8723 47.3943C44.305 46.9 45.0564 46.8501 45.5506 47.2828C46.0448 47.7154 46.0948 48.4668 45.6622 48.961C44.8934 49.839 43.7833 50.3426 42.6162 50.3426Z"
        fill="#677187"
      />
      <path
        d="M59.4283 17.8398H5.0681C2.87357 17.8398 1.09467 19.6187 1.09467 21.8133C1.09467 24.0078 2.87357 25.7867 5.0681 25.7867H59.4283C61.6228 25.7867 63.4017 24.0078 63.4017 21.8133C63.4017 19.6189 61.6226 17.8398 59.4283 17.8398Z"
        fill="#677187"
      />
      <path
        d="M10.609 21.8133C10.609 19.6187 12.3879 17.8398 14.5825 17.8398H5.0681C2.87357 17.8398 1.09467 19.6187 1.09467 21.8133C1.09467 24.0078 2.87357 25.7867 5.0681 25.7867H14.5825C12.3879 25.7867 10.609 24.0078 10.609 21.8133Z"
        fill="#4E5A73"
      />
      <path
        d="M27.1454 14.2741C26.9446 14.2741 26.741 14.2231 26.5543 14.1159C25.9846 13.7889 25.7881 13.062 26.1151 12.4923C26.6507 11.5595 26.6832 10.4283 26.2021 9.4661L25.9634 8.9886C25.125 7.31204 25.1817 5.34032 26.1151 3.71454C26.4421 3.14501 27.1692 2.94829 27.7385 3.27516C28.3082 3.60219 28.5048 4.32907 28.1779 4.8986C27.6423 5.83141 27.6098 6.96282 28.0909 7.92485L28.3296 8.40251C29.1679 10.0792 29.1112 12.0509 28.1779 13.6767C27.9581 14.0597 27.5575 14.2741 27.1454 14.2741Z"
        fill="#E8EAED"
      />
      <path
        d="M32.247 14.2245C32.0462 14.2245 31.8426 14.1735 31.6559 14.0663C31.0864 13.7393 30.8897 13.0124 31.2167 12.4429C32.0089 11.0629 32.0572 9.3893 31.3454 7.96617L31.0233 7.32195C29.9543 5.18414 30.0265 2.67024 31.2167 0.597267C31.5439 0.0275794 32.2708 -0.168827 32.8403 0.158048C33.4098 0.485079 33.6065 1.21195 33.2795 1.78164C32.4873 3.16149 32.439 4.83508 33.1508 6.25836L33.4729 6.90258C34.5418 9.04039 34.4697 11.5543 33.2795 13.6273C33.0597 14.0099 32.659 14.2245 32.247 14.2245Z"
        fill="#E8EAED"
      />
      <path
        d="M37.3487 14.2739C37.1479 14.2739 36.9443 14.223 36.7577 14.1158C36.188 13.7888 35.9915 13.0619 36.3184 12.4923C36.8538 11.5594 36.8865 10.4281 36.4054 9.4661L36.1666 8.98876C35.3282 7.31188 35.3851 5.34032 36.3184 3.71454C36.6454 3.14501 37.3724 2.94829 37.9418 3.27516C38.5115 3.60219 38.708 4.32907 38.3812 4.8986C37.8455 5.83141 37.813 6.96282 38.2941 7.92485L38.5329 8.40219C39.3712 10.0789 39.3145 12.0506 38.3812 13.6764C38.1613 14.0595 37.7607 14.2739 37.3487 14.2739Z"
        fill="#E8EAED"
      />
    </g>
    <defs>
      <clipPath id="clip0_252_107005">
        <rect width="80" height="80" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default EmptyIcon;
